<!-- MODAL Detalle de cliente -->
<div mdbModal style="overflow-y: auto" #detalleCliente="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: false }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left m-0 p-1" id="myModalLabel">
          Detalle de cliente - RUT {{ clienteSeleccionadoData?.clienteProveedor?.rutFormato | rut }}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="detalleCliente.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body detalle-cliente">
        <div class="row">
          <div class="col-2">
            <div class="waves-input-wrapper waves-light" mdbWavesEffect>
              <label mdbBtn color="primary" [(ngModel)]="currentTabs" (click)="verDetalle()" mdbRadio="detalle">
                Resumen Cliente
              </label>
            </div>
          </div>
          <div class="col-2">
            <div class="waves-input-wrapper waves-light" mdbWavesEffect>
              <label mdbBtn color="primary" [(ngModel)]="currentTabs" (click)="verAuditoria()" mdbRadio="auditoria">
                Auditoria Cliente
              </label>
            </div>
          </div>
        </div>
        <ng-container *ngIf="currentTabs === 'detalle'">
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-600 text-left p-1 m-0" id="myModalLabel">
                Datos personales
              </h5>
            </div>
          </div>
          <div class="row">
            <div class="col dato">
              <Strong class="title">Nombre</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.razon_social}}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Fecha de ingreso</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.fecha_registro | date: "dd/MM/yyyy"
                }}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Estado</Strong>
              <span class="value" *ngIf="clienteSeleccionadoData?.clienteProveedor?.activo">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </span>
              <span class="value" *ngIf="!clienteSeleccionadoData?.clienteProveedor?.activo">
                <mdb-badge pill="true" danger="true">Inactivo</mdb-badge>
              </span>
            </div>
          </div>
  
          <div class="row">
            <div class="col-6 dato">
              <Strong class="title">Canal</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.canal_descripcion }}</span>
            </div>
            <div class="col-6 dato">
              <Strong class="title">Tipo de cliente</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.tipo_cliente_nombre }}</span>
            </div>
            <!-- <div class="col dato">
              <Strong class="title">Tipo de negocio</Strong>
              <span class="value">Tipo de negocio</span>
            </div> -->
          </div>
  
          <div class="row">
            <div class="col">
              <div class="alert alert-info p-0 pl-2 mt-2" role="alert" *ngIf="!clienteSeleccionadoData?.ultimoBloqueo">
                Cliente sin bloqueos
              </div>
            </div>
          </div>
  
          <div class="row" *ngIf="clienteSeleccionadoData?.ultimoBloqueo">
            <div class="col dato">
              <Strong class="title">Último historial de bloqueo</Strong>
              <span class="value value2">
                {{ clienteSeleccionadoData?.ultimoBloqueo }}
                <!-- 01/01/2000 | 11:50 | ajara | Desbloqueo por deuda saldada -->
              </span>
            </div>
          </div>
  
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-100 text-left m-0 p-1 p-1 m-0" id="myModalLabel">
                Datos sucursales
              </h5>
            </div>
          </div>
  
          <div class="alert alert-info" role="alert" *ngIf="!clienteSeleccionadoData?.direcciones">
            Cliente sin direcciones
          </div>
          <div class="row" *ngIf="clienteSeleccionadoData?.direcciones">
            <div class="col">
              <table class="table table-striped table-hover table-sm align-middle" style="margin-top: 20px">
                <thead>
                  <tr>
                    <th scope="col" colspan="5"></th>
                    <th colspan="5">
                      IPT
                    </th>
                  </tr>
                </thead>
                <thead class="grey lighten-2">
  
                  <tr>
                    <!-- <th scope="col">ID Dirección</th> -->
                    <!-- <th scope="col">Tipo</th> -->
                    <th scope="col">Dirección</th>
                    <th scope="col">Comuna</th>
                    <th scope="col">Vend.</th>
                    <th scope="col">L</th>
                    <th scope="col">M</th>
                    <th scope="col">Mi</th>
                    <th scope="col">J</th>
                    <th scope="col">V</th>
                    <th scope="col">S</th>
                    <th scope="col">D</th>
  
                    <!-- <th scope="col">Provincia</th> -->
                    <!-- <th scope="col">Comuna</th> -->
                    <th scope="col">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let direccion of clienteSeleccionadoData?.direcciones">
                    <!-- <td>{{ direccion.codigo }}</td> -->
  
                    <td>{{ direccion.direccion_completa }}</td>
                    <td>{{ direccion.nombreComuna }}</td>
                    <td>{{ direccion.vendedor_codigo }}</td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.lunes == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.lunes == false" far icon="square"></mdb-icon>
                    </td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.martes == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.martes == false" far icon="square"></mdb-icon>
                    </td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.miercoles == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.miercoles == false" far icon="square"></mdb-icon>
                    </td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.jueves == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.jueves == false" far icon="square"></mdb-icon>
                    </td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.viernes == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.viernes == false" far icon="square"></mdb-icon>
                    </td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.sabado == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.sabado == false" far icon="square"></mdb-icon>
                    </td>
                    <td scope="col">
                      <mdb-icon *ngIf="direccion.domingo == true" far icon="check-square"></mdb-icon>
                      <mdb-icon *ngIf="direccion.domingo == false" far icon="square"></mdb-icon>
                    </td>
                    <!-- <td>{{ direccion.nombreProvincia }}</td> -->
                    <!-- <td>{{ direccion.nombreComuna }}</td> -->
                    <td>
                      <div *ngIf="direccion.activo">
                        <mdb-badge pill="true" success="true">Activo</mdb-badge>
                      </div>
                      <div *ngIf="!direccion.activo">
                        <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
  
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-100 text-left m-0 p-1 m-0 p-1" id="myModalLabel">
                Datos comerciales
              </h5>
            </div>
          </div>
  
          <div class="row">
            <div class="col dato">
              <Strong class="title">Nombre de Fantasia</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.nombre}}</span>
            </div>
            <!-- <div class="col dato">
              <Strong class="title">Dirección de facturación</Strong>
              <span class="value">{{ clienteSeleccionadoData?.direccionPrincipal?.direccion_completa}}</span>
            </div> -->
            <!-- <div class="col dato">
              <Strong class="title">Facturación a casa Matriz</Strong>
              <span class="value">
                <mdb-badge pill="true" success="true" *ngIf="clienteSeleccionadoData?.direccionPrincipal?.facturar_a_casa_matriz">Activo</mdb-badge>
                <mdb-badge pill="true" danger="true" *ngIf="!clienteSeleccionadoData?.direccionPrincipal?.facturar_a_casa_matriz">Inactivo</mdb-badge>
              </span>
            </div> -->
          </div>
  
          <!-- <div class="row">
            <div class="col dato">
              <Strong class="title">Región</Strong>
              <span class="value">Región</span>
            </div>
            <div class="col dato">
              <Strong class="title">Provincia</Strong>
              <span class="value">Provincia</span>
            </div>
            <div class="col dato">
              <Strong class="title">Comuna</Strong>
              <span class="value">Comuna</span>
            </div>
          </div> -->
  
          <div class="row">
            <div class="col dato">
              <Strong class="title">Giro comercial</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.giro }}</span>
            </div>
            <!-- <div class="col dato">
              <Strong class="title">Tipo de negocio</Strong>
              <span class="value">Tipo de negocio</span>
            </div> -->
            <div class="col dato">
              <Strong class="title">Contacto</Strong>
              <span class="value">{{ clienteSeleccionadoData?.direccionPrincipal?.nombre_contacto }}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Email de envio PDF</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.mail_pdf }}</span>
              <span class="value"
                *ngIf="clienteSeleccionadoData?.clienteProveedor?.mail_pdf === clienteSeleccionadoData?.clienteProveedor?.mail_contacto">
                <mdb-badge pill="true" success="true">Usando el mismo contacto</mdb-badge>
              </span>
            </div>
          </div>
  
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-100 text-left m-0 p-1" id="myModalLabel">
                Datos financieros
              </h5>
            </div>
          </div>
  
          <div class="row">
            <div class="col dato">
              <Strong class="title">Tipo de cobro</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.tipo_cobro_nombre }}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Lista de precios</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.lista_precio_codigo }}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Condición de pago</Strong>
              <span class="value">{{ clienteSeleccionadoData?.direccionPrincipal?.condicion_pago_nombre }}</span>
            </div>
          </div>
  
          <div class="row">
            <div class="col dato">
              <Strong class="title">Límite de crédito</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.limite_credito | numerico }}</span>
              <span class="value" *ngIf="clienteSeleccionadoData?.clienteProveedor?.limite_credito === 0">
                <mdb-badge pill="true" success="true">Sin límite</mdb-badge>
              </span>
            </div>
            <div class="col dato">
              <Strong class="title">Descuento máximo</Strong>
              <span class="value">{{ clienteSeleccionadoData?.clienteProveedor?.descuento_maximo | numerico }}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Cliente afecto a reglas comerciales</Strong>
              <span class="value">
                <mdb-badge pill="true" success="true"
                  *ngIf="clienteSeleccionadoData?.clienteProveedor?.afecto_reglas_comerciales">Activo</mdb-badge>
                <mdb-badge pill="true" danger="true"
                  *ngIf="!clienteSeleccionadoData?.clienteProveedor?.afecto_reglas_comerciales">Inactivo</mdb-badge>
              </span>
            </div>
          </div>
  
          <!-- <div class="row">
            <div class="col">
              <table
                class="table table-striped table-hover table-sm align-middle"
                style="margin-top: 20px"
              >
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col">Banco</th>
                    <th scope="col">Tipo de cuenta</th>
                    <th scope="col">Nro. de cuenta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Banco Santander</td>
                    <td>Cuenta Corriente</td>
                    <td>0198291340981234</td>
                  </tr>
                  <tr>
                    <td>Banco de Chile</td>
                    <td>Cuenta Corriente</td>
                    <td>0198291340981234</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->
  
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-100 text-left m-0 p-1" id="myModalLabel">
                Máquinas
              </h5>
            </div>
          </div>
  
          <div class="row">
            <div class="col">
              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle" style="margin-top: 20px">
                  <thead class="grey lighten-2">
                    <tr>
                      <th scope="col">Dirección</th>
                      <th scope="col">Comuna</th>
                      <!-- <th scope="col">Ciudad</th> -->
                      <th scope="col">F. Asign.</th>
                      <th scope="col">Placa</th>
                      <th scope="col">Marca</th>
                      <th scope="col">Modelo</th>
                      <!-- <th scope="col">Estado</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let maquina of clienteSeleccionadoData?.maquinas">
                      <td>{{ maquina.direccion_nombre }}</td>
                      <td>{{ maquina.comuna_nombre }}</td>
                      <!-- <td>{{ maquina.ciudad }}</td> -->
                      <td>{{ maquina.fecha_asignacion | fecha}}</td>
                      <td>{{ maquina.numero_placa }}</td>
                      <td>{{ maquina.nombre }}</td>
                      <td>{{ maquina.modelo }}</td>
                      <!-- <td>{{ maquina.estado_maquina_nombre }}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
  
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col">
              <h5 class="modal-title w-100 text-left m-0 p-1" id="myModalLabel">
                Resumen financiero
              </h5>
            </div>
          </div>
  
          <div class="row">
            <div class="col dato">
              <Strong class="title">Saldo actual Cuenta Corriente</Strong>
              <span class="value monto">{{ clienteSeleccionadoData?.resumen?.saldo_cartola | numerico }}</span>
            </div>
            <div class="col dato">
              <Strong class="title">Último pedido realizado</Strong>
  
              <div class="value monto" *ngIf="!clienteSeleccionadoData?.resumen?.totalBruto">
                Sin datos
              </div>
              <span class="value monto" *ngIf="clienteSeleccionadoData?.resumen?.totalBruto">{{
                clienteSeleccionadoData?.resumen?.totalBruto | numerico }} </span>
              <Strong class="title" *ngIf="clienteSeleccionadoData?.resumen?.fecha_emision">{{
                clienteSeleccionadoData?.resumen?.fecha_emision | date: "dd/MM/yyyy" }}</Strong>
            </div>
            <div class="col dato">
              <Strong class="title">Acumulado de pagos a cuenta</Strong>
              <span class="value monto">$ {{ clienteSeleccionadoData?.resumen?.saldo | numerico }}</span>
            </div>
          </div>
        </ng-container>
        <app-lista-auditoria *ngIf="currentTabs === 'auditoria'" [auditoria]="auditoria"></app-lista-auditoria>
      </div>
      <div class="modal-footer d-flex">
        <button type="button" size="sm" class="btn btn-sm btn-default waves-light mr-auto" data-dismiss="modal"
          (click)="detalleCliente.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" size="sm" class="btn btn-sm  btn-success waves-light" mdbWavesEffect
          (click)="detalleClientePrint()">
          <mdb-icon fas icon="print"></mdb-icon>
          imprimir
        </button>
      </div>
    </div>
  </div>
</div>
